import React from "react";

export const Team = (props) => {
  return (
    <div id="team">
      <div className="logo-bar-inner">
        <div className="logo-bar-label">Trusted Technology Partners</div>
        <div className="logo-bar-track">
          {props.data
            ? props.data.map((d, i) => (
                <div key={i} className="logo-bar-item">
                  <img src={d.img} alt="Partner logo" />
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};
